<template>
  <div id="fliggy-orders">
    <div class="header">
      <div class="title">飞猪订单（待顾客补充信息）</div>
      <div class="title-desc">此处展示尚未填写申请人出行信息的飞猪订单</div>
      <div class="sync-btn-box">
        <span>共 {{total}} 单</span>
        <div class="search-box">
          <input class="input-self" type="text" v-model="syncSearchText" placeholder="输入飞猪订单号" />
          <button
            class="sync-btn"
            :disabled="syncLoading || syncLoaded || !syncSearchText"
            @click="syncOrder(syncSearchText)"
          >同步</button>
        </div>

        <button
          class="sync-all-btn"
          :disabled="syncLoading || syncLoaded"
          @click="syncOrder()"
        >同步全部订单</button>
      </div>
    </div>
    <div class="main" v-loading="syncWait">
      <div class="order-container" v-if="fliggyOrderList.length > 0 && !isFilterOtaOrders" v-scroll="loadMore">
        <ul>
          <li class="order-item" v-for="(order, index) in fliggyOrderList" :key="index">
            <div class="top">
              <div class="product-name">{{order.product_name}}</div>
              <div class="applicant-count">{{order.item_num}}人办理</div>
              <el-button class="delete-order" type="default" @click="deleteOrder(order, index)">删除订单</el-button>
              <el-button :disabled="!canAddTravelInfo(order)" class="send-order" type="primary" @click="addApplicant(order)">填写出行信息</el-button>
            </div>
            <div class="tips-box" v-if="order.alert_desc">
              <img class="icon" src="../../assets/imgs/reject.png" />
              {{order.alert_desc}}，
              <a @click="onBindProduct(order)">重新绑定商品</a>
            </div>
            <div class="customer-list" v-if="order.applicants.length">
              <div class="customer-item" v-for="(applicant, appindex) in order.applicants" :key="appindex">
                <span class="customer-name">{{applicant.applicant_name}}</span>
                <span class="customer-identity" v-if="applicant.identity_id !== 5">{{typeof applicant.identity_id !== 'undefined' ? identityStr[applicant.identity_id] : ''}}</span>
                <span class="customer-identity" v-if="applicant.identity_id === 5">通用身份</span>
                <span class="customer-status">已在线提交</span>
              </div>
            </div>
            <div class="bottom">
              <div class="left">
                <fliggy-order-info-bar :ota-info="order" @refresh="onRefreshOrder(order)"></fliggy-order-info-bar>
              </div>
              <div class="right">
                生成时间<div class="generate-time">{{order.create_time}}</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="order-none-box" v-else>
        <img class="order-none-img" src="../../assets/imgs/order/no_order.png" />
        <div class="order-none-desc">{{condition || isFilterOtaOrders ? '这里什么都没有找到' : '当前没有新的飞猪订单，可手动同步订单'}}</div>
      </div>
    </div>

    <created-order-dialog
      :visible.sync="createdOrderInfo.show"
      :product="createdOrderInfo.product"
      :ota-order-info="createdOrderInfo.otaOrderInfo"
    ></created-order-dialog>
  </div>
</template>

<script>
import { APPLICANT_IDENTITY_MAP } from '@/maps/applicant-maps.js';
import utils from '../../libs/utils';
import Http from '../../libs/http';
import FliggyOrderInfoBar from './fliggy-order-info-bar.vue';
import fliggyRebindProductDialog from './fliggy-rebind-product-dialog/index';
import fliggyService from '@/services/modules/fliggy-service';
import CreatedOrderDialog from '@/components/add-order/created-order/created-order-dialog.vue';

export default {
  name: 'fliggyOrders',
  props: {
    // 搜索值
    condition: {
      type: String,
      default: '',
    },
    peer: {
      type: Object,
      default() {
        return {};
      },
    },
    // 是否筛选订单。如果订单列表页选择了筛选，则飞猪订单模块直接展示列表为空状态
    isFilterOtaOrders: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FliggyOrderInfoBar,
    CreatedOrderDialog,
  },
  directives: {
    scroll: {
      bind(el, binding) {
        el.addEventListener('scroll', () => {
          if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
            const loadData = binding.value;
            loadData();
          }
        });
      },
    },
  },
  data() {
    return {
      page: 1,
      total: 0,
      fliggyOrderList: [],
      isLoadAll: false, // 是否列表全部加载完了
      loading: false, // 列表加载中
      bookingModal: false, // 添加申请人弹窗
      syncSearchText: '',
      syncLoading: false, // 同步中, 用于按钮文案展示
      syncLoaded: false, // 同步完成, 用于按钮文案展示
      syncWait: false, // 同步等待中，用于点击同步按钮，需要延迟1s后执行查询list的状态,
      identityStr: APPLICANT_IDENTITY_MAP, // 身份信息
      // 创建订单弹窗
      createdOrderInfo: {
        show: false,
        product: {}, // 当前添加申请人的飞猪订单商品数据
        otaOrderInfo: undefined, // 飞猪订单信息
      },
    };
  },
  created() {
    this.getFliggyOrders();
  },
  computed: {

  },
  watch: {
    condition() {
      this.resetQueryData();
    },
  },
  methods: {
    //
    /**
     * 判断当前订单填写出行信息是否可点
     * 1. 没有告警信息
     * 2. 飞猪线上订单的所有申请人都已经提交材料
     */
    canAddTravelInfo(order) {
      return !order.alert_desc && (order.item_num === order.applicants.length || order.ota_offline);
    },
    // 删除订单
    deleteOrder(order) {
      utils.msgbox.confirm('确定删除该订单？上上签将不再同步该飞猪订单', '删除订单', {
        confirmButtonText: '　确定　',
        cancelButtonText: ' 取消 ',
        type: 'warning',
      }).then(() => {
        Http.post('/ota_order_delete', { ota_sub_order_id: order.ota_sub_order_id })
          .then(() => {
            this.resetQueryData();
          });
      });
    },

    // 刷新单个订单数据
    async onRefreshOrder(order) {
      const otaOrderInfo = await Http.post('/ota_order_query', { ota_sub_order_id: order.ota_sub_order_id });
      const index = this.fliggyOrderList.findIndex(item => item.ota_sub_order_id === order.ota_sub_order_id);
      if (index === -1) return;
      this.$set(this.fliggyOrderList, index, otaOrderInfo);
    },

    // 加载更多
    loadMore() {
      if (!this.isLoadAll) {
        this.getFliggyOrders();
      }
    },

    // 添加申请人
    async addApplicant(order) {
      try {
        const { isSuccess, data } = await fliggyService.checkFliggyStatus(order, {
          is_auth: true, // 飞猪授权过期
          status: true, // 飞猪店铺停用了
          ota_status: true, // oss后台飞猪店铺停用了
        });

        // 更新最新的状态
        if (data) order.status = data.ota_order_status;
        if (!isSuccess) return;

        const product = await Http.post('/visa_product_query', { visa_product_id: order.visa_product_id });
        this.createdOrderInfo.product = product;
        this.createdOrderInfo.otaOrderInfo = order;
        this.createdOrderInfo.show = true;
        console.log(this.createdOrderInfo);
      } catch (error) {
        console.log(error);
      }
    },
    // 重置查询条件,
    resetQueryData(isSync) {
      const box = document.querySelector('.order-container');
      if (box) {
        box.scrollTop = 0;
      }
      this.page = 1;
      this.fliggyOrderList = [];
      this.isLoadAll = false;
      this.total = 0;
      this.getFliggyOrders(isSync);
    },
    // 获取飞猪订单，isSync是否提示同步成功
    getFliggyOrders(isSync) {
      if (!this.isLoadAll && !this.loading) {
        this.loading = true;
        const params = {
          page: this.page,
          ...this.condition && { condition: this.condition },
        };
        Http.post('/ota_order_brief_query', params).then((data) => {
          this.page += 1;
          this.total = data.total_count;
          if (data.ota_order.length < 3) {
            this.isLoadAll = true;
          }
          this.fliggyOrderList = this.fliggyOrderList.concat(data.ota_order);
          this.loading = false;
          this.syncWait = false;
          this.syncLoading = false;
          if (isSync) {
            this.syncLoaded = true;
            this.$message({
              message: '飞猪订单已更新',
              type: 'success',
              onClose: () => {
                this.syncLoaded = false;
              },
            });
          }
        }).catch(() => {
          this.loading = false;
          this.syncLoading = false;
          this.syncLoaded = false;
        });
      }
    },
    // 同步订单
    syncOrder(searchText) {
      if (this.syncLoading || this.syncLoaded) return;
      this.syncLoading = true;
      Http.post('/ota_order_sync', {
        ota_sub_order_id: searchText || undefined,
      }, { noToast: true })
        .then(() => {
          if (searchText) {
            this.syncSearchText = '';
          }
          this.syncSuccess();
        }).catch((e) => {
          this.syncLoading = false;
          if (e && e.ret === -2) {
            this.unServiceTips();
          } else if (e && e.ret === -3) {
            this.autoErrorTips();
          } else if (e && e.ret === -4) {
            this.autoErrorTips(true);
          } else if (e && e.ret === -5) {
            this.storeDisableTips();
          } else {
            this.$message({
              message: e && e.msg ? e.msg : '同步失败，请重试',
              type: 'error',
            });
          }
        });
    },
    // 同步成功， 由于后台同步异步，需延迟1S后再执行
    syncSuccess() {
      this.syncWait = true;
      setTimeout(() => {
        this.resetQueryData(true);
        this.syncSearchText = '';
      }, 1000);
    },
    // 授权过期提示 isSync：是否同步了订单，如果同步了，则提示并重新请求
    autoErrorTips(isSync = false) {
      utils.msgbox.confirm('当前飞猪店铺授权已过期，请使用飞猪店铺管理员账号重新绑定授权', '飞猪店铺提示', {
        confirmButtonText: '去授权',
        cancelButtonText: '忽略该提示',
        type: 'warning',
      }).then(() => {
        const { href } = this.$router.resolve({ path: '/user/shop' });
        window.open(href, '_blank');
        isSync && this.syncSuccess();
      }).catch(() => {
        isSync && this.syncSuccess();
      });
    },
    // 没有开通订单服务提示
    unServiceTips() {
      utils.msgbox.confirm('您尚未开通飞猪订单同步服务，请联系商务经理', '飞猪店铺提示', {
        confirmButtonText: '知道了',
        type: 'warning',
        showCancelButton: false,
      }).then(() => {
      });
    },
    // 店铺已禁用提示
    storeDisableTips() {
      utils.msgbox.confirm('当前飞猪店铺已禁用，请重新启用飞猪店铺', '飞猪店铺提示', {
        confirmButtonText: '立即启用',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const { href } = this.$router.resolve({ path: '/user/shop' });
        window.open(href, '_blank');
      }).catch(() => {
      });
    },
    onBindProduct(order) {
      fliggyRebindProductDialog.show({
        ota_sub_order_id: order.ota_sub_order_id,
      }).then(() => {
        // 修改成功，更新数据
        this.onRefreshOrder(order);
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import  '../../assets/less/variable';
#fliggy-orders {
  border-radius: 4px;
  border: solid 1px rgba(94, 155, 225, 0.5);
  max-height: 380px;
  min-height: 190px;
  overflow: hidden;
  margin-bottom: 20px;
  .header {
    background-color: #eaf3ff;
	  box-shadow: 0px 1px 0px 0px#f0f0f0;
    border-radius: 4px 4px 0px 0px;
    height: 50px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    .title {
      font-size: 16px;
      line-height: 18px;
      font-weight: 600;
      color: #333;
      padding-left: 12px;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        border-radius: 1px;
        left: 0;
        top: 0;
        background-color: @main;
        width: 3px;
        height: 18px;
      }
    }
    .title-desc {
      font-size: 14px;
      color: #aaa;
      flex-grow: 1;
    }
    .sync-btn-box{
      display: flex;
      align-items: center;
      font-size: 14px;

      span{
        margin-right: 20px;
        color: #aaaaaa;
      }
      
      .search-box{
        border-radius: 4px;
        overflow: hidden;
        border: 1px solid #5E9BE1;
        height: 32px;
        display: flex;
        align-items: center;
        margin-right: 20px;
        .input-self{
          flex-shrink: 0;
          border: none;
          overflow: hidden;
          width: 128px;
          height: 100%;
          padding: 0 10px;
          outline: none;
        }
        .sync-btn{
          flex-shrink: 0;
          border: none;
          background: #5E9BE1;
          padding: 0 12px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #fff;
          cursor: pointer;
          &[disabled]{
            opacity: 0.7;
            cursor: not-allowed;
          }
        }

      }

      .sync-all-btn{
        flex-shrink: 0;
        border: none;
        background: #5E9BE1;
        padding: 0 12px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #fff;
        cursor: pointer;
        border-radius: 4px;
        &[disabled]{
          opacity: 0.7;
          cursor: not-allowed;
        }
      }
      
      
    }
  }
  .main {
    background-color: #f7f8fa;
    .order-container {
      max-height: 330px;
      overflow-y: auto;
      padding: 20px;
      ul {
        list-style-type: none;
        .order-item {
          background-color: #ffffff;
          box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
          border-radius: 4px;
          margin-bottom: 20px;
          display: flex;
          flex-direction: column;
          &:last-child {
            margin-bottom: 0;
          }
          .top {
            padding: 0 20px;
            display: flex;
            height: 58px;
            border-bottom: 1px solid @border;
            display: flex;
            align-items: center;
            .product-name {
              font-size: 16px;
              color: @text-dark;
              width: 490px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .applicant-count {
              flex: 1;
              text-align: right;
              font-size: 14px;
              color: #777;
              margin-right: 40px;
            }
            .delete-order {
              padding: 0;
              font-size: 14px;
              color: #777;
              border: solid 1px #cfcfcf;
              line-height: 1;
              padding: 7px 11px;
            }
            .send-order {
              margin-left: 20px;
              font-size: 14px;
              color: #fff;
              line-height: 1;
              padding: 7px 11px;
            }
          }
          .tips-box{
            background-color: #fff7f7;
            height: 40px;
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #ff5a60;
            padding: 0 20px;
            line-height: 1;
            .icon{
              width: 16px;
              height: 16px;
              margin-right: 8px;
            }
            a{
              font-weight: 600;
              text-decoration: underline;
              color: #ff5a60;
            }
          }
          .customer-list {
            padding: 0 20px;
            .customer-item {
              display: flex;
              align-items: center;
              height: 84px;
              border-bottom: 1px dashed #f0f0f0;
              .customer-name {
                display: block;
                width: 220px;
                margin-right: 20px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                font-size: 16px;
                color: #333;
              }
              .customer-identity {
                display: block;
                width: 194px;
                font-size: 16px;
                color: #aaa;
              }
              .customer-status {
                display: block;
                font-size: 16px;
                color: #333;
              }
            }
          }
          .bottom {
            display: flex;
            align-items: center;
            padding: 0 20px;
            height: 40px;
            .left {
              padding-right: 20px;
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 14px;
              color: #777;
              display: flex;
              align-items: center;
              .fliggy-logo {
                width: 22px;
                flex-shrink: 0;
              }
              .fliggy-name {
                margin-left: 10px;
                flex-shrink: 1;
                max-width: 230px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .fliggy-order-num {
                margin-left: 5px;
                color: #777;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                flex-shrink: 0;
                color: #5e9be1;
              }
            }
            .right {
              font-size: 14px;
              color: #aaa;
              display: flex;
              .generate-time {
                margin-left: 8px;
              }
            }
          }
        }
      }
    }
    .order-none-box{
      height: 250px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #fff;
      .order-none-desc{
        color: #6f6f6f;
        font-size: 14px;
        margin-top: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ota/fliggy-orders.vue